import { Loader } from 'rsuite';
import './index.css';

export default function LoaderComponent({ size='lg', content='Loading', fullscreen=false }) {
  return (
    <div className="loader-fade-wrapper" style={ !fullscreen ? {} : {position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <Loader data-testid="loader-component" style={{zIndex: 99999}} size={size} content={content} vertical backdrop center />
    </div>
  );
}